// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"e57f3bd8","796":"a0581105"}[chunkId] + ".chunk.js";
};